import { render, staticRenderFns } from "./DigiBoardSettingsDetails.vue?vue&type=template&id=5b952806&scoped=true&"
import script from "./DigiBoardSettingsDetails.vue?vue&type=script&lang=js&"
export * from "./DigiBoardSettingsDetails.vue?vue&type=script&lang=js&"
import style0 from "./DigiBoardSettingsDetails.vue?vue&type=style&index=0&id=5b952806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b952806",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VForm,VIcon,VRow,VTextarea})
